import { formatTeamSelectLabel, Nullish, TeamType } from 'types'

/**
 * `Add Member` heading that names the team the member is added to,
 * e.g. `Add Member: LT – Memory Unit A`.
 */
export function getAddMemberModalTitle(
  teamName: Nullish<string>,
  teamType?: Nullish<TeamType>,
): string {
  if (!teamName) return 'Add Member'

  const teamLabel = teamType ? formatTeamSelectLabel({ name: teamName, type: teamType }) : teamName
  return `Add Member: ${teamLabel}`
}
